import React from "react";
import FiberImg from '../../../../assets/images/fibraOptica.jpg';


import './styles.css';
import "font-awesome/css/font-awesome.min.css";

const Fiber = () => {

    return (
        <div className="container">
            <div className="row">
                <div className="siglas-title">
                    <h1>Fibra Óptica</h1>
                </div>
                <div className="col-sm-12">
                    <div className="siglas">
                        <img src={FiberImg} alt="siglas" />
                    </div>
                </div>                
            </div>
        </div>
    );
};
export default Fiber;